module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAR9JREFUOE/d07FKA0EQBuB/DmPrK6QVX8EqhY34Ar7AroJBhex5lzq7d4mKgiG7j2ApWAnWtmKRWh9DwRs5NSDJbbKGs3HbHb6dGf4l1HyoZg//DOxlbpeILYjiVIlR1bqCRzZm1Go0oqe3AvcAN1Ml15YG9cAeE9MpMS6L91dNK6utRMnrpUDTd0cAzpi5nKZAhM20Ix986Zg7sh64Q2Kcf2OMiPbSjnDzouYFde7aAF8An9Eq29tPYmkX5bYSzDK7UxBuJhgzHXRPxHARVt5XgiZ3twze/uqM2kksrkIwL6hz+wLwI1E0TJS4C8W84G+A6drgYIc+MgP2cjcm8HoQQBinSm78rJ0BTd9tlV8rCAQ9T+/470cO68xfVXuHHyldVxUq41OnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ico/ic_edit.png
// module id = xATM
// module chunks = 1